import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { setAuthenticated } from '../../../utils/auth';

export const AuthCallback = () => {
  useEffect(() => {
    setAuthenticated();
  }, []);

  return <Navigate to='/dashboard' replace />;
};
